<template>
  <div>
    <div>
      <Navbar />
      <HeaderComparate />
      <SelectsComparator />
    </div>

    <div>
      <Contents />
    </div>

    <div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/layout/Navbar";
import Contents from "./components/Contents.vue";
import HeaderComparate from "../../components/cabecera/HeaderComparate.vue";
import SelectsComparator from "../../components/cabecera/SelectsComparator.vue";
import Footer from "../../components/layout/Footer.vue";
export default {
  components: {
    Navbar,
    Contents,
    HeaderComparate,
    Footer,
    SelectsComparator
  },
  mounted() {
    this.$store.commit("setSelectedMainView", "comparator");
  }
};
</script>
